<nx-ng-technical-difficulties
  [closeTextKey]="'return_ticket_selection'"
  [showInitial]="true"
  (close)="handleCloseClicked()"
></nx-ng-technical-difficulties>
